import axios from 'axios';

const API_URL = process.env.REACT_APP_BASEURL + 'notification';
const API_URL2 = process.env.REACT_APP_BASEURL + 'notifyMessage';

export const addNotification = (reqData: Object) => {
  return axios.post(API_URL + '/add', reqData);
};
export const updateNotification = (reqData: Object) => {
  return axios.put(API_URL + '/', reqData);
};
export const notificationStatusChange = (reqData: Object) => {
  return axios.put(API_URL + '/status', reqData);
};
export const getAllNotification = (reqData: Object) => {
  return axios.get(API_URL + '/all', { params: reqData });
};
export const deleteNotification = (deleteReq: Object) => {
  return axios.delete(API_URL + '/', { params: deleteReq });
};